// src/site/js/elexio-constent.js
import { cookieGet, cookieSet, parseJson, parseOptions, translate } from './helpers.js';

document.addEventListener('DOMContentLoaded', function () {
    	
	modalConsentInit();
});

function modalConsentInit() {
	
	let c_ = cookieGet('elx_pref_consent');
	c_ = c_ && parseJson(c_);
	
	let modalConsentContentHtml = translate('modal_consent_content');
	if (window.elexio.shop.name == '') {
		modalConsentContentHtml = translate('modal_consent_content_default');
	}	
		modalConsentContentHtml = modalConsentContentHtml.replace('{{ shop_name }}', window.elexio.shop.name);
		modalConsentContentHtml = modalConsentContentHtml.replace('{{ shop_url }}', window.elexio.shop.url);
		modalConsentContentHtml = modalConsentContentHtml.replace('{{ more_information_link }}', `<button 
							type="button" 
							class="link cursor-pointer"
							@click="$dispatch('open-consent-modal', { url: '/request/modal-consent/?consent=cookie_information' })"
						>
							${translate('more_information')}
						</button>`);

    /**/
	const cookieHtml = `
	<div class="fixed flex items-center justify-center w-[4.2rem] h-[4.2rem] p-[0.6rem] left-[3rem] bottom-[10rem] cursor-pointer elx-modal-consent-clip${c_ !== null ? '' : ' !hidden'}"
		 data-event="show" data-target="elx-modal-consent-clip">
		<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"
			 fill="none" stroke-linecap="round" stroke-linejoin="round">
			<path d="M25 45.833s16.667 -8.333 16.667 -20.833V10.417l-16.667 -6.25 -16.667 6.25v14.583c0 12.5 16.667 20.833 16.667 20.833z"/>
			<path d="m18.75 25 4.167 4.167 8.333 -8.333"/>
		</svg>
	</div>

	<div class="fixed elx-modal-consent${c_ !== null ? ' elx-modal-consent--configured !hidden' : ' elx-modal-consent--unconfigured'}" data-cookie-options="{\'name\': \'elx_pref_consent\', \'expired\': \'30\', \'path\': \'/\'}">

		<span class="close cursor-pointer" data-event="close" data-target="elx-modal-consent">
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
				<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"></path>
			</svg>
		</span>
		
		<div class="elx-modal-consent__content">
			<div class="elx-modal-consent__info flex items-start">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M321.5 91.6C320.7 86.2 316.6 81.8 311.2 81C289.1 77.9 266.6 81.9 246.8 92.4L172.8 131.9C153.1 142.4 137.2 158.9 127.4 179L90.7 254.6C80.9 274.7 77.7 297.5 81.6 319.5L96.1 402.3C100 424.4 110.7 444.6 126.8 460.2L187.1 518.6C203.2 534.2 223.7 544.2 245.8 547.3L328.8 559C350.9 562.1 373.4 558.1 393.2 547.6L467.2 508.1C486.9 497.6 502.8 481.1 512.6 460.9L549.3 385.4C559.1 365.3 562.3 342.5 558.4 320.5C557.5 315.2 553.1 311.2 547.8 310.4C496.3 302.2 455 263.3 443.3 213C441.5 205.4 435.3 199.6 427.6 198.4C373 189.7 329.9 146.4 321.4 91.6zM272 208C289.7 208 304 222.3 304 240C304 257.7 289.7 272 272 272C254.3 272 240 257.7 240 240C240 222.3 254.3 208 272 208zM208 400C208 382.3 222.3 368 240 368C257.7 368 272 382.3 272 400C272 417.7 257.7 432 240 432C222.3 432 208 417.7 208 400zM432 336C449.7 336 464 350.3 464 368C464 385.7 449.7 400 432 400C414.3 400 400 385.7 400 368C400 350.3 414.3 336 432 336z"/></svg>

				<p>${modalConsentContentHtml}</p>
			</div>

			<div class="cookies-choice-settings cookies-choice-switch">
				<div class="flex flex-wrap cookies-setting-essential">
					<input type="checkbox" class="form-control form-control--checkbox" data-checkbox-switch="true" id="pref_essential" checked="checked" disabled="disabled">
					<label for="pref_essential" class="flex-1">${translate('essential_cookies')}
						<button 
							type="button" 
							class="link cursor-pointer"
							@click="$dispatch('open-consent-modal', { url: '/request/modal-consent/?consent=essential' })"
						>
							${translate('more_information')}
						</button>						
						<br /><span>${translate('always_active')}</span>
					</label>
				</div>
				<div class="flex flex-wrap items-center">
					<input type="checkbox" class="form-control form-control--checkbox" data-checkbox-switch="true" id="pref_preferences"${c_?.pref_preferences === 'granted' ? 'checked' : ''}>
					<label for="pref_preferences">${translate('preferences')}
						<button 
							type="button" 
							class="link cursor-pointer"
							@click="$dispatch('open-consent-modal', { url: '/request/modal-consent/?consent=preferences' })"
						>
							${translate('more_information')}
						</button>
					</label>
				</div>
				<div class="flex flex-wrap items-center">
					<input type="checkbox" class="form-control form-control--checkbox" data-checkbox-switch="true" id="pref_marketing"${c_?.pref_marketing === 'granted' ? 'checked' : ''}>
					<label for="pref_marketing">${translate('marketing')}
						<button 
							type="button" 
							class="link cursor-pointer"
							@click="$dispatch('open-consent-modal', { url: '/request/modal-consent/?consent=marketing' })"
						>
							${translate('more_information')}
						</button>
					</label>
				</div>
				<div class="flex flex-wrap items-center">
					<input type="checkbox" class="form-control form-control--checkbox" data-checkbox-switch="true" id="pref_analytics"${c_?.pref_analytics === 'granted' ? 'checked' : ''}>
					<label for="pref_analytics">${translate('analytics')}
						<button 
							type="button" 
							class="link cursor-pointer"
							@click="$dispatch('open-consent-modal', { url: '/request/modal-consent/?consent=analytics' })"
						>
							${translate('more_information')}
						</button>
					</label>
				</div>
				<div class="flex flex-wrap justify-end privacy-policy-info">
					<button 
						type="button" 
						class="link cursor-pointer"
						@click="$dispatch('open-consent-modal', { url: '/request/modal-consent/?consent=privacy-policy' })"
					>
						${translate('privacy_policy')}
					</button>
				</div>
			</div>

			<div class="elx-modal-consent__buttons">
				<div class="elx-modal-consent-button elx-modal-consent-button--info-apply-all align-items-center" data-event="elexio-consent-info-apply-all">
					<span class="cursor-pointer btn sm" title="${translate('apply_all')}">${translate('apply_all')}</span>
				</div>
				<div class="elx-modal-consent-button elx-modal-consent-button--info-apply align-items-center" data-event="elexio-consent-info-apply">
					<span class="cursor-pointer btn sm" title="${translate('save_selection')}">${translate('save_selection')}</span>
				</div>
				<div class="elx-modal-consent-button elx-modal-consent-button--info-settings align-items-center" data-event="elexio-consent-info-settings">
					<span class="cursor-pointer btn btn--outline sm"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.559.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.894.149c-.424.07-.764.383-.929.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.398.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.272-.806.108-1.204-.165-.397-.506-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894Z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /></svg> ${translate('cookie_settings')}</span>
				</div>
			</div>

		</div>
	</div>

	<div x-data="{ 
		open: false, 
		isLoading: false, 
		hasError: false,
		consentContent: '',

		init() {
			// Luister naar het openen/sluiten van de modal
			this.$watch('open', value => {
				if (value) {
					// Blokkeer scrollen op de body
					document.body.classList.add('body-scroll-disabled');
				} else {
					// Geef scrollen weer vrij
					document.body.classList.remove('body-scroll-disabled');
					// HTML weggooien na de sluit-animatie (voorkomt conflicten)
					setTimeout(() => { 
						this.consentContent = ''; 
						this.hasError = false; 
					}, 300);
				}
			});
		},

		async loadConsent(url) {
			this.open = true;
			this.isLoading = true;
			this.hasError = false; // Reset error bij nieuwe laadpoging

			try {
				const response = await fetch(url, {
					method: 'GET',
					headers: {
						'X-Requested-With': 'XMLHttpRequest'
					}
				});

				if (!response.ok) throw new Error('Pagina niet gevonden');

				// Haal de ruwe HTML op 
				const html = await response.text(); 
				this.consentContent = html;

			} catch (error) {
				console.error('Fout bij laden van consent modal:', error);
				this.hasError = true; // Activeer de error-status in plaats van HTML te printen
			} finally {
				this.isLoading = false;
			}
		}
	}"
	@open-consent-modal.window="loadConsent($event.detail.url)"
	@keydown.escape.window="open = false"
	style="position: relative; z-index: 9999;">

		<template x-teleport="body">
			<div class="drawer drawer--consent" data-drawer="modal" x-show="open" :class="{ 'show': open }" style="display: none;">
				<div class="drawer__bg" @click="open = false"></div>

				<div class="card shadow" @click.outside="open = false">
					<div class="card-header">
						<button class="cursor-pointer close" @click="open = false" aria-label="Sluiten">
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
								<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"></path>
							</svg>
						</button>
					</div>
					<div class="card-body">
						<div x-show="isLoading" class="absolute flex items-center justify-center inset-0">
							 <svg class="circular-spin w-8 h-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
								 <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" class="opacity-25"></circle>
								 <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" class="opacity-75"></path>
							 </svg>
						</div>

						<div x-show="hasError" class="p-6 text-red-500" style="display: none;">
							Fout bij het laden van de inhoud.
						</div>

						<div x-show="!isLoading && !hasError" x-html="consentContent" x-ref="modalContainer"></div>
					</div>
				</div>
			</div>
		</template>
	</div>
	`;

	const divC = document.createElement('div');
	// add text content to the paragraph
	divC.innerHTML = cookieHtml;

	document.body.appendChild(divC);
	
	/**/
	const elexioModalConsentClip = document.body.querySelector('[data-event="show"][data-target="elx-modal-consent-clip"]');
	if (!elexioModalConsentClip) return;

	elexioModalConsentClip.addEventListener('click', function (e) {
		e.preventDefault();
		
		this.classList.add('!hidden');
		document.body.querySelector('[data-target="elx-modal-consent"]').parentElement.classList.remove('!hidden');
	});	
	
	/**/
	const elexioModalConsentClose = document.body.querySelector('[data-event="close"][data-target="elx-modal-consent"]');
	if (!elexioModalConsentClose) return;

	elexioModalConsentClose.addEventListener('click', function (e) {
		e.preventDefault();

		document.body.querySelector('[data-target="elx-modal-consent"]').parentElement.classList.add('!hidden');
		document.body.querySelector('[data-event="show"][data-target="elx-modal-consent-clip"]').classList.remove('!hidden');
	});	

	/**/
	const elexioModalConsentApplyAll = document.body.querySelector('[data-event="elexio-consent-info-apply-all"]');

	elexioModalConsentApplyAll.addEventListener('click', function (e) {
		e.preventDefault();

		document.getElementById('pref_marketing').checked = true;
		document.getElementById('pref_preferences').checked = true;
		document.getElementById('pref_analytics').checked = true;

		elexioConsentSet('all');

		const el = document.body.querySelector('[data-target="elx-modal-consent"]').parentElement;
			  el.classList.add('!hidden', 'elx-modal-consent--configured');
			  el.classList.remove('elx-modal-consent--unconfigured');

		document.body.querySelector('[data-event="show"][data-target="elx-modal-consent-clip"]').classList.remove('!hidden');
	});	

	/**/
	const elexioModalConsentApply = document.body.querySelector('[data-event="elexio-consent-info-apply"]');

	elexioModalConsentApply.addEventListener('click', function (e) {
		e.preventDefault();
		
		elexioConsentSet('choice');

		const el = document.body.querySelector('[data-target="elx-modal-consent"]').parentElement;
			  el.classList.add('!hidden', 'elx-modal-consent--configured');
			  el.classList.remove('elx-modal-consent--unconfigured');

		document.body.querySelector('[data-event="show"][data-target="elx-modal-consent-clip"]').classList.remove('!hidden');
	});	

	/**/
	const elexioModalConsentSettings = document.body.querySelector('[data-event="elexio-consent-info-settings"]');

	elexioModalConsentSettings.addEventListener('click', function (e) {
		e.preventDefault();
		
		this.classList.add('!hidden');

		document.body.querySelector('.cookies-choice-settings').classList.add('!block');
		document.body.querySelector('.elx-modal-consent-button--info-apply').classList.add('!block');
	});	
	
	if (c_ !== null) {
		// Als er al een cookie is (bezoeker heeft eerder al gekozen), 
		// stuur deze voorkeuren dan direct door naar GTM, ProfitMetrics, etc.
		elexioConsentSet('page_load'); 
	}	
}

function elexioConsentSet(update_consent) {
    // Element ophalen
    const el = document.body.querySelector('.elx-modal-consent');
    if (!el) {
        return;
    }

	// Consent-waardes set
	const consentValues = {
		pref_marketing:   document.getElementById('pref_marketing').checked   ? 'granted' : 'denied',
		pref_preferences: document.getElementById('pref_preferences').checked ? 'granted' : 'denied',
		pref_analytics:   document.getElementById('pref_analytics').checked   ? 'granted' : 'denied'
	};

	// ---- Cookie zetten met plain JS ----
	const rawOptions = el.getAttribute('data-cookie-options');
	const cookieOptions = parseOptions(rawOptions);

	// Injecteer value → consentValues JSON
	cookieOptions.value = JSON.stringify(consentValues);

	cookieSet(cookieOptions);

    // ---- Consent-cookie uitlezen ----
	let c_ = cookieGet('elx_pref_consent');
		c_ = parseJson(c_);

    if (
        !c_ ||
        c_.pref_marketing   === undefined ||
        c_.pref_preferences === undefined ||
        c_.pref_analytics   === undefined
    ) {
        return;
    }

    // ---- Zorg dat gtag altijd correct gedefinieerd is ----
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}

    // ---- GA/gtag consent update (Dit moet wél op elke pagina gebeuren) ----
    gtag('consent', 'update', {
        ad_storage:              c_.pref_marketing,
        ad_personalization:      c_.pref_marketing,
        ad_user_data:            c_.pref_marketing,
        personalization_storage: c_.pref_preferences,
        analytics_storage:       c_.pref_analytics,
        functionality_storage:  'granted',
        security_storage:       'granted'
    });

    // ---- Custom events naar GTM (Alleen via dataLayer.push, géén dubbele gtag events) ----
    if (typeof dataLayer !== 'undefined') {
        
        // Optioneel: Je kunt de statussen altijd pushen zodat GTM de variabelen kent
        dataLayer.push({
            event: 'pref_consent_marketing',
            consent: c_.pref_marketing
        });
        dataLayer.push({
            event: 'pref_consent_preferences',
            consent: c_.pref_preferences
        });
        dataLayer.push({
            event:   'pref_consent_analytics',
            consent: c_.pref_analytics
        });

        // CRITICAAL: Stuur het 'consent_update' event alléén als de bezoeker écht 
        // een keuze maakt via de banner, niet bij het simpelweg laden van een nieuwe pagina.
        if (update_consent !== 'page_load') {
            dataLayer.push({
                event: 'consent_update',
                value: update_consent
            });
        }
    }
	
	// ---- Squeezely / Spotler Activate consent ----
    if (typeof window._sqzl !== 'undefined') {
        window._sqzl = window._sqzl || [];

        // Maak array's aan voor wat geaccepteerd en geweigerd is
        let sqzlGranted = [];
        let sqzlRevoked = [];

        // Check Analytics
        if (c_.pref_analytics === 'granted') {
            sqzlGranted.push('analytics');
        } else {
            sqzlRevoked.push('analytics');
        }

        // Check Marketing
        if (c_.pref_marketing === 'granted') {
            sqzlGranted.push('marketing');
        } else {
            sqzlRevoked.push('marketing');
        }

        // Stuur de geaccepteerde permissies naar Spotler
        if (sqzlGranted.length > 0) {
            _sqzl.push({
                consent: "grant",
                permissions: sqzlGranted
            });
        }

        // Stuur de geweigerde permissies naar Spotler
        if (sqzlRevoked.length > 0) {
            _sqzl.push({
                consent: "revoke",
                permissions: sqzlRevoked
            });
        }
    }	

    // ---- HRQ / tracking opt-out ----
    if (typeof window.hrq !== 'undefined') {
        window.hrq = window.hrq || [];

        hrq.push([
            'setTrackingOptOut',
            c_.pref_marketing !== 'granted'
        ]);

        hrq.push([
            'getTrackingOptOut',
            function (optout) {
                // If optout is true the user has opted out
                trace('=== getTrackingOptOut', optout);
            }
        ]);
    }
	
	if (typeof window.profitMetrics !== 'undefined') {
        window.profitMetrics.cookieStatisticsConsent = (c_.pref_analytics === 'granted');
        window.profitMetrics.cookieMarketingConsent  = (c_.pref_marketing === 'granted');
    }
}